import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "form"]

  connect() {
    this.debounceTimer = null
  }

  disconnect() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
  }

  search() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => {
      this.submitForm()
    }, 250)
  }

  submitForm() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
